<template>
  <div class="flex flex-col gap-4">
    <main-knowledge-breadcrumb-wrapper @go-to-entity="goToEntity" :custom-width="350" />

    <collection-view
      class="bg-gray-1"
      :config="getConfig()"
      :item-is-favorite="itemIsFavorite"
      @go-to-entity="goToEntity"
      @copy-link="copyLink({ ...$event, lang: selectedLanguage })"
      @open-in-web="openInWeb({ ...$event, lang: selectedLanguage })"
      @toggle-favorite="toggleFavorite"
      @empty-view="fixEmptyView"
    />
  </div>
</template>

<script setup lang="ts">
import useEntities from '@commons/composables/useEntities'
import { useFavoritesStore, useKnowledgeStore } from '@getmayday/vue-modules'

const { goToEntity, toggleFavorite, getConfig, copyLink, openInWeb } = useEntities()
const { itemIsFavorite } = useFavoritesStore()

const knowledgeStore = useKnowledgeStore()
const { selectedLanguage } = storeToRefs(knowledgeStore)

const { fixEmptyView } = useApp()
</script>
